import { CommonScriptComponent } from './../common-script/common-script.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cto-for-startups',
  templateUrl: './cto-for-startups.component.html',
  styleUrls: ['./cto-for-startups.component.css']
})
export class CtoForStartupsComponent implements OnInit {

  constructor(private commonScriptComponent:CommonScriptComponent) { }

  ngOnInit() {
    this.commonScriptComponent.onLoad();
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/cto-for-startups/cto-for-startups.component.ts